import { motion, useReducedMotion } from 'framer-motion';
import './EmptyState.css';

function EmptyState({ icon = '📭', title, description, action }) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className="ds-empty-state"
      initial={reduceMotion ? false : { opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, ease: [0.4, 0, 0.2, 1] }}
    >
      <div className="ds-empty-icon" aria-hidden="true">{icon}</div>
      <div className="ds-empty-title">{title}</div>
      {description && <div className="ds-empty-description">{description}</div>}
      {action && <div className="ds-empty-action">{action}</div>}
    </motion.div>
  );
}

export default EmptyState;
